import { useMutation, useQuery } from '@tanstack/react-query';
import { useLoginStore } from './login.store';
import { useCreateStore } from '@/entities/create';
import { lcmsApi, lmsApi, teachingtoolApi, vivasamApi } from '@/shared/api/common';
import { loginApi } from '@/shared/api/login';

export const getLoginState = () => {
    const loginState = useLoginStore.getState();
    return loginState;
};

export const getCreateState = () => {
    const createState = useCreateStore.getState();
    return createState;
};

const useTexbookCurrListQuery = (params: API.TextbookMetaCrcuList.Req, enabled: boolean) =>
    useQuery({
        queryKey: ['getTextbookMetaCuruEngList', params],
        queryFn: async () => lmsApi.getTextbookMetaCrcuList(params),
        enabled: enabled,
        // placeholderData: keepPreviousData,
    });

const useLesnRscMdulExamScopeL = (params: API.LesnRscMdulExamScope.Req, enabled: boolean) =>
    useQuery({
        queryKey: ['getTextbookMetaCuruEngList'],
        queryFn: async () => lcmsApi.getLesnRscMdulExamScopeL(params),
        enabled: enabled,
        // placeholderData: keepPreviousData,
    });

const useSessionInfo = (enabled: boolean) =>
    useQuery({
        queryKey: ['getLoginInfo'],
        queryFn: async () => loginApi.getSessionInfo(),
        refetchOnWindowFocus: true,
        enabled: enabled,
    });

const useCodeToClass = (textbook: string, enabled: boolean) =>
    useQuery({
        queryKey: ['getCodeToClass', textbook],
        queryFn: async () =>
            vivasamApi.getCodeToClass({
                textbook: textbook,
            }),
        refetchOnWindowFocus: true,
        enabled: enabled,
    });

const useLesnRscSetSummaryList = () =>
    useMutation({
        mutationKey: ['getLesnRscSetSummaryList'],
        mutationFn: async (params: API.LesnRscSetSummaryList.Req) =>
            lcmsApi.postLesnRscSetSummaryList(params),
    });

const useLesnRscSetSummaryListQuery = (setId?: string) =>
    useQuery({
        queryKey: ['getLesnRscSetSummaryList', setId],
        queryFn: async () =>
            lcmsApi.postLesnRscSetSummaryList({
                set_ids: [setId ?? ''],
                orderby_col: 'id',
                orderby_dir: 'asc',
                limit_page: '1',
                limit_pageItemCnt: 9999,
            }),
        enabled: Boolean(setId),
        select: (response) => response.data.vo?.[0]?.setSummary ?? [],
    });

const useContactSave = () =>
    useMutation({
        mutationKey: ['postContactSave'],
        mutationFn: async (params: string) => vivasamApi.postContactSave(params),
    });

const useContactSavePod = () =>
    useMutation({
        mutationKey: ['postContactSavePod'],
        mutationFn: async (params: string) => vivasamApi.postContactSavePod(params),
    });

const useGetShortUrlToken = () =>
    useMutation({
        mutationKey: ['postGetShortUrlToken'],
        mutationFn: async (params: API.ShortUrlToken.Req) =>
            teachingtoolApi.postGetShortUrlToken(params),
    });

const useGetShortUrl = () =>
    useMutation({
        mutationKey: ['postGetShortUrl'],
        mutationFn: async (params: API.ShortUrl.Req) => teachingtoolApi.postGetShortUrl(params),
    });

export const commonQueries = {
    getSessionInfo: useSessionInfo,
    getTextbookCurrList: useTexbookCurrListQuery,
    getLesnRscMdulExamScopeL: useLesnRscMdulExamScopeL,
    getCodeToClass: useCodeToClass,
    postLesnRscSetSummaryList: useLesnRscSetSummaryList,
    getLesnRscSetSummaryList: useLesnRscSetSummaryListQuery,
    postContactSave: useContactSave,
    postContactSavePod: useContactSavePod,
    postGetShortUrlToken: useGetShortUrlToken,
    postGetShortUrl: useGetShortUrl,
};
